import Vue from 'vue';

const SET_ALL_TAGS = 'SET_ALL_TAGS';
const SET_TAGS = 'SET_TAGS';
const SET_TAG = 'SET_TAG';
const UNSET_TAG = 'UNSET_TAG';

export default {
  namespaced: true,
  state: {
    allTags: [],
    tags: null,
    tag: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [SET_ALL_TAGS](state, tags) {
      state.allTags = tags;
    },
    [SET_TAGS](state, tags) {
      state.tags = tags;
    },
    [SET_TAG](state, tag) {
      state.tag = tag;
    },
    [UNSET_TAG](state) {
      state.tag = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    getAllTags({ commit }) {
      return Vue.axios.get('tags', {
        params: { show: 'all' },
      }).then(({ data }) => commit(SET_ALL_TAGS, data));
    },
    getTags({ commit }, { page }) {
      return Vue.axios.get('tags', {
        params: { page },
      }).then(({ data }) => commit(SET_TAGS, data));
    },
    getTag({ commit }, slug) {
      return Vue.axios.get(`tags/${slug}`)
        .then(({ data }) => commit(SET_TAG, data));
    },
    unsetTag({ commit }) {
      commit(SET_TAG);
    },
  },
  getters: {
    allTags: state => state.allTags,
    tags: state => state.tags,
    tag: state => state.tag,
  },
};
